import { toast } from 'react-toastify';

import ToastComponent from '../components/CheckoutV2/Toast';

export default function useToaster() {
  function addSuccess(text) {
    return toast(<ToastComponent type="success" text={text} />, {
      autoClose: 3000,
      toastId: 'success',
    });
  }

  function addError(text) {
    return toast(<ToastComponent type="error" text={text} />, {
      autoClose: 3000,
      toastId: 'error',
    });
  }

  return {
    addSuccess,
    addError,
  };
}
